export default {
  priority: 5,
  path: "assignment",
  permissions: ["Salary/PaySlipMenu"], // component: Definition,
  component: load(() =>
    import(/* webpackChunkName: "Shift-Definition" */ "./Report")
  ),
  name: app.translate("گزارش گیری"),
  icon: "account-check",
  drawer: true,
};
